import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Game from './pages/Game';
import GameIntermission from './pages/GameIntermission';
import GameEnd from './pages/GameEnd';
import GameGuide from './pages/GameGuide';
import Survey from './pages/Survey';
import SurveyEnd from './pages/SurveyEnd';
import Article from './pages/Article';
import NotFound from './pages/NotFound';
import { GameProvider } from './context/GameContext';
import { LanguageProvider } from './context/LanguageContext';
import ScrollToTop from './components/general/ScrollToTop';

function App() {
  return (
    <LanguageProvider>
      <GameProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/game" element={<Game />} />
            <Route path="/game/intermission" element={<GameIntermission />} />
            <Route path="/game/end" element={<GameEnd />} />
            <Route path="/game/guide" element={<GameGuide />} />
            <Route path="/survey" element={<Survey />} />
            <Route path="/survey/end" element={<SurveyEnd />} />
            <Route path="/notFound" element={<NotFound />} />
            <Route path="/article/howWeBuiltGITSB" element={<Article />} />
            <Route path="*" element={<Navigate to="/notFound" replace />} />
          </Routes>
        </BrowserRouter>
      </GameProvider>
    </LanguageProvider>
  );
}

export default App;
